import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const WalletListContainer = React.lazy(
  () => import('../../containers/wallet-list/wallet-list.container')
);
const WalletDetailsContainer = React.lazy(
  () => import('../../containers/wallet-details/wallet-details.container')
);

export const WalletsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.WALLETS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.WALLETS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <DefaultLayout
        authenticationRequired={true}
        permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
        component={WalletListContainer}
      />
    )
  },
  {
    path: (APP_ROUTES.WALLETS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <DefaultLayout
        authenticationRequired={true}
        permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
        component={WalletDetailsContainer}
      />
    )
  }
];
